"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerListHeaderStyles = styles_1.makeStyles(function (theme) { return ({
    headerContainer: {
        display: 'flex',
        verticalAlign: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 40,
        background: theme.palette.background.header,
    },
    headerTitle: {
        textTransform: 'uppercase',
        fontWeight: 400,
        alignSelf: 'center',
        color: theme.palette.common.white,
    },
}); }, { name: 'Checkout_DealerListHeader' });
exports.default = dealerListHeaderStyles;
